import { Link, NavLink, useNavigate } from "react-router-dom";
import { Radar, LogOut, LayoutGrid, Boxes, Globe2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Layout({ children }) {
  const { user, workspace, logout } = useAuth();
  const navigate = useNavigate();

  const linkClass = ({ isActive }) =>
    [
      "px-3 py-2 rounded-sm uppercase tracking-widest text-xs font-semibold transition-all duration-200 flex items-center gap-2",
      isActive
        ? "bg-cyan-500/10 text-cyan-300 border border-cyan-400/40"
        : "text-slate-400 hover:text-cyan-300 border border-transparent hover:border-cyan-500/25",
    ].join(" ");

  return (
    <div className="min-h-screen speculo-grid-bg text-slate-200">
      <header
        className="sticky top-0 z-40 border-b border-cyan-500/15 bg-[#040d14]/85 backdrop-blur-md"
        data-testid="top-nav"
      >
        <div className="max-w-[1400px] mx-auto px-6 py-3 flex items-center justify-between">
          <Link to="/globe" className="flex items-center gap-3 group" data-testid="brand-link">
            <div className="relative w-8 h-8 rounded-sm border border-cyan-400/60 flex items-center justify-center speculo-glow">
              <Radar className="w-4 h-4 text-cyan-300" />
              <span className="absolute -bottom-1 -right-1 w-2 h-2 rounded-full bg-cyan-400 speculo-pulse" />
            </div>
            <div className="leading-tight">
              <div className="text-lg font-bold tracking-[0.22em] text-cyan-200">SPECULO</div>
              <div className="text-[10px] text-cyan-500/70 tracking-[0.35em] uppercase font-mono">
                Global Insight
              </div>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-1" data-testid="primary-nav">
            <NavLink to="/globe" className={linkClass} data-testid="nav-globe">
              <Globe2 className="w-3.5 h-3.5" /> Globe
            </NavLink>
            <NavLink to="/dashboard" className={linkClass} data-testid="nav-dashboard">
              <LayoutGrid className="w-3.5 h-3.5" /> Logs
            </NavLink>
            <NavLink to="/apps" className={linkClass} data-testid="nav-apps">
              <Boxes className="w-3.5 h-3.5" /> Applications
            </NavLink>
          </nav>

          <div className="flex items-center gap-4">
            <div className="hidden sm:flex flex-col text-right" data-testid="nav-user">
              <span className="text-xs text-cyan-300 uppercase tracking-widest">
                {workspace?.name || "workspace"}
              </span>
              <span className="text-[11px] text-slate-400 font-mono" data-testid="nav-user-email">
                {user?.email || ""}
              </span>
            </div>
            <button
              type="button"
              onClick={() => {
                logout();
                navigate("/login");
              }}
              className="flex items-center gap-2 px-3 py-2 rounded-sm border border-[#FF003C]/30 text-[#ff4d70] uppercase tracking-widest text-xs hover:bg-[#FF003C]/10 transition-all"
              data-testid="logout-button"
            >
              <LogOut className="w-3.5 h-3.5" /> Logout
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-[1400px] mx-auto px-6 py-8" data-testid="main-content">
        {children}
      </main>
    </div>
  );
}
